export enum FeatureToggle {
  InsightsPortalAdsDashboard = 'rt_insights_portal_ads_dashboard',
  InsightsPortalAdsDashboardV2 = 'rt_insights_portal_ads_dashboard_v2',
  InsightsPortalAdsDashboardPromotions = 'rt_insights_portal_ads_dashboard_promotions',
  InsightsPortalDisplayReview = 'rt_insights_portal_display_review',
  InsightsPortalAdsDashboardRetailers = 'rt_insights_portal_ads_dashboard_retailers',
  InsightsCampaignInsights = 'rt_insights_campaign_insights',
  InsightsCampaignInsightsDisabledRetailers = 'rt_insights_campaign_insights_disabled_retailers',
  InsightsHideICStoreConfiguration = 'rt_insights_hide_ic_store_configuration',
  InsightsCreativeInsights = 'rt_insights_creative_insights',
  InsightsShowCampaignsEducationalBanner = 'rt_show_campaigns_educational_banner',
  InsightsDashboardBuilder = 'rt_insights_dashboard_builder',

  InsightsPortalAwarenessCampaignsDashboard = 'rt_insights_portal_awareness_campaigns_dashboard',
  InsightsPortalAdsDashboardCaper = 'rt_insights_portal_ads_dashboard_caper',
  InsightsPortalDrtMidterm = 'rt_insights_portal_drt_midterm_frontend_change',
  InsightsPortalDrtAdvancedFeatures = 'rt_insights_portal_drt_advanced_features',
  InsightsCancelledOrdersReport = 'rt_insights_cancelled_orders_report',
  InsightsPortalDrtDemandSource = 'rt_insights_portal_drt_demand_source',

  // collections
  RetailerCollectionsV2Ux = 'rt_retailer_collections_ux_v2',

  // moments
  campaignV2TemplateMomentEnabled = 'rt_campaigns_v2_template_moment_enabled',

  // Future Scheduled Orders
  FutureScheduledOrders = 'rt_future_scheduled_orders',

  IppAiAgent = 'rt_ipp_ai_agent',
}
